import { render, staticRenderFns } from "./customerbody.vue?vue&type=template&id=20e74272"
import script from "./customerbody.vue?vue&type=script&lang=js"
export * from "./customerbody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports